import createLazyComponent from '../LazyComponent';

const Redemption = createLazyComponent(() => import('./RedemptionPage'));

export default Redemption;
